import {
  take,
  call,
  cancelled,
  put,
  race,
  select,
  delay,
  takeEvery
} from "redux-saga/effects";
import pusher from "../store/Pusher.js";

import { endpointsSaga, selectEndpointByTypeSaga } from "./endpointSagas.js";
import { operationSaga } from "./operationSagas.js";

import { OPERATIONS } from "../../constants/operations.js";
import { AT_TYPES } from "../../constants/entity.js";
import { AUTHENTICATION } from "../reducers/authentication/authenticationConstants.js";
import {
  AUTH_REFRESH_THRESHOLD,
  AUTH_INACTIVITY_THRESHOLD,
  AUTH_INACTIVITY_WARNING_TIMEOUT
} from "../../constants/authenticationConstants.js";

import coreActions from "../reducers/core/coreActions.js";
import { operationAction as createOperationAction } from "../reducers/operations/operationActions.js";
import { decodeTokenPayload } from "../reducers/authentication/authenticationUtils.js";
import { createAction } from "../actions/actionUtils.js";

import {
  showInactivityWarning,
  doLogout,
  latestActivity
} from "../reducers/authentication/authenticationActions.js";

import { ROUTES } from "../../constants/routing.js";

// -- SELECT QUERIES -- //

export const getExp = state => state.authentication.exp;
export const getTokens = state => state.authentication.tokens;
export const getLastActive = state => state.authentication.lastActivity;

// -- EVENT SAGAS -- //

// ================================ //
//  FEDERATED LOGIN SAGAS (OAUTH)  //
// ================================ //

// redirect to federated auth url
function* loginFederatedLinkSaga(action) {
  console.log("login federated saga");

  try {
    const operationAction = createOperationAction(
      AUTHENTICATION.LOGIN_FEDERATED_LINK,
      yield call(selectEndpointByTypeSaga, AT_TYPES.USER),
      OPERATIONS.LOGIN_FEDERATED_LINK,
      action.payload,
      { showErrorModal: false }
    );

    const response = yield call(operationSaga, operationAction, true);

    const link = response?.url;

    if (link) {
      // redirect browser to provider
      window.location.href = link;
    } else {
      // no link returned from backend
      console.warn("loginFederatedLinkSaga :: No redirect link returned");

      yield put({
        type: AUTHENTICATION.LOGIN_FEDERATED_LINK.FAILURE,
        payload: {
          message: "No federated login provider found for this email."
        }
      });
    }
  } catch (err) {
    console.error("loginFederatedLinkSaga :: Error ::", err);
  }
}

// callback: exchange oauth code -> tokens
function* loginFederatedExchangeSaga(action) {
  try {
    const operationAction = createOperationAction(
      AUTHENTICATION.LOGIN_FEDERATED_EXCHANGE,
      yield call(selectEndpointByTypeSaga, AT_TYPES.USER),
      OPERATIONS.LOGIN_FEDERATED_EXCHANGE,
      action.payload,
      { showErrorModal: false }
    );

    const token = yield call(operationSaga, operationAction, true);

    if (token) {
      yield put(createAction(AUTHENTICATION.LOGIN.RECEIVE, token));

      return token;
    }
  } catch (err) {
    console.error("loginFederatedExchangeSaga :: Error ::", err);

    const message = "FEDERATED_EXCHANGE_FAILED";

    window.location.href = `${
      ROUTES.FEDERATED_LOGIN_LINK
    }?error=${encodeURIComponent(message)}`;
  }
}

// ------------------------------ //
// Watcher saga for federated login
// ------------------------------ //
export function* watchFederatedLogin() {
  yield takeEvery(
    AUTHENTICATION.LOGIN_FEDERATED_LINK.DO,
    loginFederatedLinkSaga
  );
  yield takeEvery(
    AUTHENTICATION.LOGIN_FEDERATED_EXCHANGE.DO,
    loginFederatedExchangeSaga
  );
}
